<section class="container">
  <div class="header-wrapper">
    <h1>Packages</h1>
  </div>


  <div class="content-wrapper">
    <mat-form-field style="width: 100%">
      <input matInput placeholder="Release Notes ..."
        [(ngModel)]="releaseNotes" autofocus autocomplete="off">
    </mat-form-field>

    <div class="button">
      <a mat-raised-button class="mat-accent"
        [disabled]="!this.hasPackagesForRelease"
        (click)="createRelease()"
        id="create-release" data-qa-id="packages-btn-create-release">
        Create Release
      </a>
    </div>

    <table class="mdl-data-table" data-qa-id="packages-table">
      <thead>
        <tr>
          <th>Package</th>
          <th style="text-align: center">Version</th>
          <th>Created On</th>
          <th>Created By</th>
          <th>Updated On</th>
          <th>Status</th>
          <th>Include Package in Release</th>
          <th>Controls</th>
        </tr>
      </thead>
      <tbody>
        @if (loading) {
          <tr>
            <td colspan="8" class="loading">
              <aw-spinner></aw-spinner>
            </td>
          </tr>
        }
        @if (!loading) {
          @for (packageGroup of packageGroups; track packageGroup) {
            <tr>
              <td>{{ packageGroup.MajorPackage.PackageName | translate: 'Text' | async }}</td>
              <td style="text-align: center">{{ packageGroup.MajorPackage.Version }}</td>
              <td>{{ packageGroup.MajorPackage.CreatedOn | date : 'dd/MM/yyyy HH:mm:ss' }}</td>
              <td>{{ packageGroup.MajorPackage.CreatedBy }}</td>
              <td>{{ packageGroup.MajorPackage.UpdatedOn | date : 'dd/MM/yyyy HH:mm:ss' }}</td>
              <td>
                @if (!packageGroup.MajorPackage.Disabled) {
                  <div>
                    @if (packageGroup.PackageCreationRules.MajorPackage.OutOfSync) {
                      <mat-icon color="warn">cloud_off</mat-icon>
                    }
                    @if (!packageGroup.PackageCreationRules.MajorPackage.OutOfSync) {
                      <mat-icon color="accent">cloud_done</mat-icon>
                    }
                  </div>
                }
              </td>
              <td>
                <mat-checkbox [disabled]="packageGroup.MajorPackage.Disabled || !packageGroup.MajorPackage.IsReleaseAllowed"
                  [(ngModel)]="packageGroup.MajorPackage.IsChecked"
                  (change)="onSelectedPackageChange()"
                  id="include-package-{{packageGroup.MajorPackage.Id}}">
                </mat-checkbox>
              </td>
              <td>
                @if (!hideResetButton && packageGroup.PackageCreationRules.MinorPackage.CanCreatePackageForThisVersion && permissionService.hasPermission(permissions.editVersion)) {
                  <a mat-raised-button class="mat-warn"
                    (click)="resetToSpecificVersion(packageGroup.MajorPackage.PackageType, packageGroup.MajorPackage.Version)"
                    id="reset-to-specific-version-{{packageGroup.MajorPackage.PackageType}}-{{packageGroup.MajorPackage.Version}}">
                    ↩ Reset and Edit
                  </a>
                }
              </td>
            </tr>
            @for (minorPackage of packageGroup.MinorPackages; track minorPackage) {
              <tr class="minor-package">
                <td>&nbsp;</td>
                <td style="text-align: center">{{ minorPackage.Version }}.{{ minorPackage.MinorVersion }}</td>
                <td>{{ minorPackage.CreatedOn | date : 'dd/MM/yyyy HH:mm:ss' }}</td>
                <td>{{ minorPackage.CreatedBy }}</td>
                <td>&nbsp;</td>
                <td>
                  @if (!minorPackage.Disabled) {
                    <div>
                      @if (packageGroup.PackageCreationRules.MinorPackage.OutOfSync) {
                        <mat-icon color="warn">cloud_off</mat-icon>
                      }
                      @if (!packageGroup.PackageCreationRules.MinorPackage.OutOfSync) {
                        <mat-icon color="accent">cloud_done</mat-icon>
                      }
                    </div>
                  }
                </td>
                <td>
                  <mat-checkbox [disabled]="minorPackage.Disabled || !minorPackage.IsReleaseAllowed"
                    [(ngModel)]="minorPackage.IsChecked"
                    (change)="onSelectedPackageChange()"
                    id="include-package-{{minorPackage.Id}}">
                  </mat-checkbox>
                </td>
                <td>&nbsp;</td>
              </tr>
            }
          }
        }
      </tbody>
    </table>
    <mat-paginator [length]="totalCount"
      [pageSize]="pageSize"
      [hidePageSize]="true"
      (page)="onPageChange($event)">
    </mat-paginator>
  </div>
</section>
